import type { FC } from "react";

import style from "./styles/Form.module.scss";

export interface FormInputHintProps {
  children: React.ReactNode;
  align: "start" | "end";
}

const FormInputHint: FC<FormInputHintProps> = (props) => {
  return (
    <span className={style.input_hint} style={{ alignSelf: props.align }}>
      {props.children}
    </span>
  );
};

export { FormInputHint };
